import React from 'react';
import { visionTimeline } from '../data/data';

const VisionSection = () => {
  return (
    <section id="vision" className="py-32 px-6 text-center bg-[#0f0f10]/50">
      
      {/* TITLE */}
      <h2 className="text-4xl md:text-5xl font-bold mb-12">
        Future <span className="text-cyan-400 glow">Vision</span>
      </h2>

      <p className="text-gray-400 max-w-2xl mx-auto mb-16">
        Blending human creativity with AI to build systems that feel alive
      </p>

      {/* TIMELINE */}
      <div className="relative max-w-4xl mx-auto">

        {/* LINE */}
        <div className="absolute left-1/2 top-0 bottom-0 w-[2px] bg-cyan-400/20 transform -translate-x-1/2"></div>

        <div className="space-y-16">
          {visionTimeline.map((item, index) => {
            const isLeft = index % 2 === 0;

            return (
              <div key={index} className="relative">

                {/* CONTENT */}
                <div className={`flex ${isLeft ? 'justify-start' : 'justify-end'}`}>
                  <div className="w-full md:w-1/2">

                    <div className="bg-[#111]/60 backdrop-blur-lg border border-cyan-400/20 rounded-2xl p-6 text-left transition-all duration-300 hover:border-cyan-400 hover:shadow-[0_0_40px_rgba(0,255,255,0.2)]">

                      <p className="text-sm text-cyan-400 mb-2 uppercase tracking-wider">
                        {item.phase}
                      </p>

                      <h3 className="text-xl font-bold mb-2">
                        {item.title}
                      </h3>

                      <p className="text-gray-300">
                        {item.description}
                      </p>

                    </div>

                  </div>
                </div>

                {/* DOT */}
                <div className="absolute left-1/2 top-4 transform -translate-x-1/2">
                  <div className="w-4 h-4 bg-cyan-400 rounded-full shadow-[0_0_15px_rgba(0,255,255,0.8)]"></div>
                </div>

              </div>
            );
          })}
        </div>

      </div>

    </section>
  );
};

export default VisionSection;